/**
 * Battle rake (platform fee) rate — single source of truth for every
 * battle payout path (matchmaking, private, invite, resolve, forfeit,
 * rush settlement).
 *
 * BETA: Crowns battles pay the winner the FULL combined pot — no rake.
 * A rake only starts after the beta ends. To re-enable it later, flip
 * this one constant (e.g. 0.05 for 5%) and every payout path picks it
 * up at once. Keep user-facing copy in sync (BalanceExplainerModal,
 * HowItWorksModal, SocialFeedPage) when this changes.
 *
 * In-flight matchups created before the rake was zeroed carry a 10%
 * platformFee on their row. Decision: resolve/forfeit recompute the fee
 * at settlement time (rate 0 → full pot, the generous beta-friendly
 * outcome), while Rush honors the payout stored at creation. Both are
 * acceptable during beta; only new rows matter going forward.
 */
const BATTLE_RAKE_RATE = 0;

module.exports = { BATTLE_RAKE_RATE };
